export const openLinkInNewTab = (link: string | undefined) =>
  window.open(link, "_blank");
